import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'

interface LatestStatementData {
  allMdx: {
    nodes: Array<{
      id: string
      frontmatter: {
        title: string
        excerpt?: string
        date: string
      }
      fields: {
        slug: string
      }
    }>
  }
}

const LatestStatement: React.FC = () => {
  const data = useStaticQuery<LatestStatementData>(graphql`
    query LatestStatementQuery {
      allMdx(
        filter: { internal: { contentFilePath: { regex: "/content/statements/" } } }
        sort: { frontmatter: { date: DESC } }
        limit: 1
      ) {
        nodes {
          id
          frontmatter {
            title
            excerpt
            date
          }
          fields {
            slug
          }
        }
      }
    }
  `)

  const statement = data.allMdx.nodes[0]

  if (!statement) {
    return (
      <div className="text-center py-8">
        <h3 className="text-xl font-semibold text-text-light mb-2">
          No statements yet
        </h3>
        <p className="text-text-light">
          Committee statements will appear here once they're published.
        </p>
      </div>
    )
  }

  return (
    <Link
      to={statement.fields.slug}
      key={statement.id}
      className="block"
    >
      <article className="bg-gray-50 rounded-lg px-4 py-6 hover:bg-gray-100 transition-colors border border-border">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
          <div className="flex-1">
            <h2 className="font-semibold text-lg md:text-xl mb-2 mt-0">
              {statement.frontmatter.title}
            </h2>
            <div className="flex flex-wrap items-baseline gap-2 text-sm text-text-light">
              <span>
                {new Date(statement.frontmatter.date).toLocaleDateString('en-GB', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric'
                })}
              </span>
              {statement.frontmatter.excerpt && (
                <>
                  <span>•</span>
                  <span className="line-clamp-2">
                    {statement.frontmatter.excerpt}
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="text-primary font-medium text-sm whitespace-nowrap self-center">
            Read →
          </div>
        </div>
      </article>
    </Link>
  )
}

export default LatestStatement